import { Injectable, signal } from '@angular/core';
import {
    HttpErrorResponse,
    HttpRequest,
    HttpResponse,
} from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class AdminTestApiService {
    activeTestAreas = new Set<AdminTestApiArea>();
    testAreaEvents = signal<AdminTestApiHttpEvents[]>([]);

    setAreaActive(area: AdminTestApiArea) {
        this.activeTestAreas.add(area);
    }

    setAreaInactive(area: AdminTestApiArea) {
        this.activeTestAreas.delete(area);
    }

    /**
     * Creates a new test event for the given HTTP request and updates the signal with the new event.
     * @returns The created AdminTestApiHttpEvents instance representing the test event.
     */
    createTestEvent(request: HttpRequest<any>): AdminTestApiHttpEvents {
        const currentEvents = this.testAreaEvents();
        const newEvent = new AdminTestApiHttpEvents(
            currentEvents.length + 1,
            request
        );

        // Update the signal with the new event
        this.testAreaEvents.set([...currentEvents, newEvent]);
        return newEvent;
    }
}

export class AdminTestApiHttpEvents {
    timestamp = new Date();
    requestName: string;
    response = signal<HttpResponse<any> | null>(null);
    responseError = signal<HttpErrorResponse | null>(null);

    constructor(
        public id: number,
        public request: HttpRequest<any>
    ) {
        this.requestName = request.url.split('/').pop() ?? '';
    }
}

export enum AdminTestApiArea {
    WA_ARTICLE,
    ARTICLE_COMPARE,
    ASN,
    DESADV,
}
